<template>
  <div class="error">
    <el-result icon="error" title="404" subTitle="页面不存在或路径错误或页面无权限">
      <template slot="extra">
        <el-button type="primary" size="medium" @click="$router.push('/layout/home')">返回首页</el-button>
      </template>
    </el-result>
  </div>
</template>
<script>
export default {
  name: 'error',
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {

  }
}
</script>
<style scoped lang="less">
</style>